import PropTypes from "prop-types";
import { TextInputReadOnly } from "components/form_new";
import useTranslate from "hooks/use-translate-language";
import { formatDate, formatPhone } from "utils/misc";

const Insurance = ({ insurances }) => {
  const translate = useTranslate();
  return (
    <div className="profile-panel">
      {insurances.map((x, index) => (
        <div key={index} style={index === 1 ? { marginTop: "20px" } : {}}>
          <div className="profile-panel-content">
            <TextInputReadOnly
              label={
                index === 0
                  ? translate("primaryInsurance")
                  : translate("secondaryInsurance")
              }
              value={x.insurance_company_name}
            />
            <TextInputReadOnly
              label={translate("policyNumber")}
              value={x.plan_no}
            />
            <TextInputReadOnly
              label={translate("groupNumber")}
              value={x.group}
            />

            <TextInputReadOnly
              label={translate("insurancePhoneNumber")}
              value={formatPhone(x.insurance_phone)}
            />

            <TextInputReadOnly
              label={translate("policyStartDate")}
              value={formatDate(x.policy_start_date)}
            />
            <TextInputReadOnly
              label={translate("policyEndDate")}
              value={formatDate(x.policy_end_date)}
            />
          </div>
          <div className="profile-panel-content" style={{ marginTop: "20px" }}>
            <TextInputReadOnly
              label={translate("guarantorName")}
              value={x.guarantor_name}
            />
            <TextInputReadOnly
              label={translate("guarantorRelationship")}
              value={x.guarantor_relation}
            />
            <TextInputReadOnly
              label={translate("guarantorDob")}
              value={formatDate(x.guarantor_dob)}
            />
          </div>
          <div className="profile-panel-content" style={{ marginTop: "20px" }}>

            <TextInputReadOnly
              label={translate("insuranceStreetAddress")}
              value={x.insurance_address.street_address}
            />
            <TextInputReadOnly
              label={translate("insuranceStreetAddress2")}
              value={x.insurance_address.street_address2}
            />
            <TextInputReadOnly
              label={translate("insuranceCity")}
              value={x.insurance_address.city}
            />
            <TextInputReadOnly
              label={translate("insuranceState")}
              value={x.insurance_address.state}
            />
            <TextInputReadOnly
              label={translate("insuranceZip")}
              value={x.insurance_address.zip}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

Insurance.propTypes = {
  insurances: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default Insurance;
